<template>
    <div class="foot">
        <div class="wraps">
            <div class="foot_top">
                <div class="top_left">
                    <p>联系我们</p>
                    <p>服务热线：010-56254029</p>
                    <p>商务合作： sales@bmi-tech.cn</p>
                    <p>详细地址：北京市海淀区北三环中路44号C308</p>
                    <div class="top_right">
                        <p>关于我们</p>
                        <img src="../../assets/images/76.png" class="imgs_foot">
                    </div>
                </div>
            </div>
            <div class="foot_bom wraps">
                <p>京公网安备：11010802025138号    版权所有 ©  Copyright 司马达拓（深圳）智能系统有限公司 All Rights Reserved. BMI Technologies Co., Ltd.. </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "my-footer",
    data() {
        return {
            
        }
    }
}
</script>

<style>
    .foot {
        width: 100%;
        background: #262d33;
        font-family: "MicrosoftYaHei";
        color: #ffffff;
    }
    .wraps {
        width: 1200px;
        margin: 0 auto;
    }    
    /* 底部上方文字 */
    .foot_top {
        padding-top: 47px;
    }
    /* 左侧第一个文字 */
    .top_left p:nth-child(1) {
        font-size: 24px;
    }

    .top_left p:nth-child(2)  {
        font-size: 19px;
        margin-top: 40px;
    }
    .top_left p:nth-child(3)  {
        font-size: 19px;
        margin-top: 35px;
    }
    .top_left p:nth-child(4)  {
        font-size: 19px;
        margin-top: 32px;
    }
    .top_left {
        position: relative;
    }
    /* 右侧二维码 */
    .top_right {
        /* width: 160px; */
        /* height: 248px; */
        position: absolute;
        top: 0px;
        right: 0px;
    }
    .top_right p:nth-child(1) {
        font-size: 24px;
        margin: 0;
        text-align: center;
        margin-bottom: 25px;
    }
    .top_right img {
        width: 160px;
        height: 160px;
    }


    /* 下方版权 */
    .foot_bom {
        border-top: 1px solid #bbbbbb;
        margin-top: 20px;
    }

    .foot_bom p{
        font-size: 16px;
        white-space: pre-wrap;
        padding-top: 23px;
        padding-bottom: 30px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/cuscom/footer.vue